import { Box, Button, Card, CardContent, CardHeader, Divider, Table, TableBody, TableCell, TableHead, TableRow, TextField } from "@mui/material"
import { useEffect, useState } from "react";
import { T_Place } from "../../../common/model/placeModel";
import { CCardFooter } from "@coreui/react";
import NeonModal from "../../../component/neon/NeonModal";
import DaumPostcode from 'react-daum-postcode';
import { useLocation, useNavigate } from "react-router-dom";
import apis from "../../../common/apis";
import { initialAlert, useAlert } from "../../../provider/AlertContextProvider";

export default function PlaceEdit(){
    const { state } = useLocation();
    // state.inqueryData 에서 넘어온 item 객체를 꺼낼 수 있습니다.
    const inputData = state?.item;

    const nav = useNavigate();
     const {alert,setAlert} = useAlert();
     
    const [data,setData] = useState<T_Place>({});

    const infoData = async()=>{
        const result = await apis.place.placeInfo({idx:inputData.idx})
        if(result.code=="1"){
            setData(result.data);
        }
    }   

    const updateData = async()=>{
       
          setAlert({...alert,title:"확인",msg:"정말로 수정 하시겠습니가?",visible:true,buttonList:[
            {
                text:"예"
                ,variant:"contained"
                ,onPress:async()=>{
                    console.log("place data:",data)
                   const result = await apis.place.placeUpdate(data)
                   console.log("result:",result)
                    if(result.code=="1"){
                        setAlert(initialAlert);
                        // setAlert({...alert,visible:true,title:"확인",msg:"수정이 완료되었습니다."})
                        nav("/place")
                    }else{
                        setAlert(initialAlert);
                        setAlert({...alert,visible:true,title:"확인",msg:"수정중 오류가 발생했습니다.."})
                    }
           
                }
            },{
                text:"아니요"
                ,variant:"outlined"
                ,onPress:()=>{
                    setAlert(initialAlert);
                }
            }
        ]})

    }

useEffect(()=>{
    infoData();
},[])

    return(
    <>
    <Card >
        <CardHeader title="현장 수정" sx={{pb:0,mb:0}}/>
        <CardContent>
            <Divider />
        <Table  stickyHeader aria-label="sticky table"  sx={{borderTopWidth:2
          }} > 
            <TableHead />
            <TableBody>
            <TableRow>
                    <TableCell component="th" scope="row" sx={{width:150}}>
                          현장명
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}}>
                          <TextField  size="small" fullWidth value={data.name || ''} onChange={(event)=>{setData({...data,name:event.target.value})}} />
                        </TableCell>      

        </TableRow>        

        <TableRow>
                    <TableCell component="th" scope="row" sx={{width:150}}>
                          주소
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}}>
                            <Box sx={{flexDirection:'column'}}>
                          <TextField 
                            disabled
                            rows={1}
                            size="small"
                            sx={{mb:1}}
                            value={data.zipcode || ''} onChange={(event)=>{setData({...data,zipcode:event.target.value})}}
                          />
                          {/* <Button onClick={handlePost}>우편번호찾기</Button> */}
                            </Box>
                        
                          <TextField 
                            disabled
                            size="small"
                            rows={1}
                            sx={{mb:1}}
                            fullWidth 
                            value={data.addr || ''} onChange={(event)=>{setData({...data,addr:event.target.value})}}
                          />
                          <TextField 
                            size="small"
                            rows={1}
                            fullWidth 
                            value={data.addr2 || ''} onChange={(event)=>{setData({...data,addr2:event.target.value})}}
                          />
                        </TableCell>      

        </TableRow>          
        <TableRow>
                    <TableCell component="th" scope="row" sx={{width:150}}>
                          비고
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}}>
                            <TextField multiline
                            rows={10}
                            fullWidth 
                            value={data.content || ''} onChange={(event)=>{setData({...data,content:event.target.value})}}
                          />                                           
                        </TableCell>      

        </TableRow>        
        </TableBody>

        </Table>

        </CardContent>
        <CCardFooter style={{   display: 'flex',justifyContent:'center',textAlign:'center',paddingBottom:10, gap: '1rem'}}  >
        <Button variant="contained" onClick={()=>{
        updateData();
    }}>수정</Button>
        <Button variant="outlined" onClick={()=>{
        nav(-1);
    }}>취소</Button>

        </CCardFooter>
    </Card>
 
    </>)
}